/* eslint-disable camelcase */
/* eslint-env browser */
import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { setupStore } from './store/configureStore';
import AppComponent from './components/AppComponent';
import './style/style.scss';

declare global {
  interface Window {
    serviceemp_header: string;
    serviceemp_text: string;
    serviceemp_hint: string;
    serviceemp_search: string;
  }
}

const store = setupStore();
const rootElement = document.querySelector('.app-service-employees-container');
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(rootElement!);
root.render(
  <StrictMode>
    <Provider store={store}>
      <AppComponent />
    </Provider>
  </StrictMode>,
);
